<template>
  <div class="creator">
    <creator-icon class="creator__creator-icon"></creator-icon>
    <div class="creator__creator-title">Creator</div>
    <div class="creator__my-account-title">My Account</div>
    <div class="creator__description">
      This page contains your account details, payment methods and more.
    </div>
  </div>
</template>

<script>
import CreatorIcon from 'Svgs/creator-icon.svg?inline';

export default {
  name: 'Creator',
  components: {
    CreatorIcon,
  },
};
</script>

<style scoped lang="scss">
.creator {
  display: grid;
  grid-template-rows: 1fr 1fr 3fr;
  grid-template-columns: 1fr 8fr 3fr;
  height: 290px;
  background: $white-main;
  @media (min-width: $xxs-up) and (max-width: $xs-up) {
    grid-template-rows: 1fr 1fr 4fr;
  }
  &__creator-icon {
    grid-column: 1;
    margin: 2rem auto auto 2rem;
    @media (min-width: $xxs-up) and (max-width: $xs-up) {
      margin: 2rem auto auto 1rem;
    }
  }
  &__creator-title {
    grid-column: 2;
    margin: 38px auto auto -1.5rem;
    width: 101px;
    height: 34px;
    color: $blue-main;
    font-family: $politica-font;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 1.03px;
    line-height: 53px;
    text-transform: uppercase;

    @media (max-width: $xl-up) {
      margin: 38px auto auto 0;
    }
  }
  &__my-account-title {
    grid-column: 1 / 3;
    grid-row: 2;
    margin-left: 3rem;
    width: 308px;
    height: 44px;
    color: $blue-main;
    font-family: $istok-font;
    font-size: 36px;
    font-weight: 700;
    letter-spacing: 0.57px;
    line-height: 53px;
    @media (min-width: $xxs-up) and (max-width: $xs-up) {
      margin-left: 1rem;
      width: 290px;
    }
  }
  &__description {
    grid-column: 1 / 3;
    grid-row: 3;
    margin-left: 3rem;
    margin-top: 12px;
    width: 850px;
    height: 60px;
    color: $blue-main;
    font-family: $palanquin-font;
    font-size: 18px;
    font-weight: 400;
    line-height: 30px;
    @media (max-width: $lg-up) {
      width: 760px;
    }
    @media (min-width: $xs-up) and (max-width: $sm-up) {
      width: 100%;
    }
    @media (min-width: $xxs-up) and (max-width: $xs-up) {
      width: 100%;
      margin-left: 1rem;
    }
  }
}
</style>
